import { RenderTargetFormat } from "../../../RenderEngine/RenderEnum/RenderTargetFormat";
import { RenderTexture } from "../../../resource/RenderTexture";
export class WebXRRenderTexture extends RenderTexture {
    constructor() {
        super(1, 1, 1, RenderTargetFormat.STENCIL_8, false, 1);
        this.frameLoop = -1;
    }
    set frameBuffer(value) {
        this._frameBuffer = value;
    }
    _create(width, height) {
    }
}
